import React from "react";

import { Button, ButtonType, Card, Flex, Icon, Typography } from "components";

export type EmptyStateCardProps = {
  type?: "primary" | "secondary";
  iconName: string;
  title: string;
  description: string;
  buttonText: string;
  buttonType?: ButtonType;
  children?: React.ReactNode;
  dataTestId?: string;
  onButtonClick: () => void;
};

export const EmptyStateCard = ({
  type = "primary",
  iconName,
  title,
  description,
  buttonText,
  buttonType = "primary",
  children,
  dataTestId,
  onButtonClick,
}: EmptyStateCardProps) => {
  const isSecondary = type === "secondary";

  return (
    <Card dataTestId={dataTestId}>
      <Flex className="card-body-container" vertical align="center" justify="center" gap={32}>
        <Flex vertical align="center">
          <Flex className="padding-150">
            <Icon iconName={iconName} size={48} color="#6D6D6D" />
          </Flex>
          <Flex vertical align="center" gap={4} className="title-description-container center">
            {isSecondary ? (
              <Typography variant="paragraph-m" color="grey-600" data-testid={dataTestId ? `${dataTestId}-title` : undefined}>
                {title}
              </Typography>
            ) : (
              <Typography variant="h5" bold data-testid={dataTestId ? `${dataTestId}-title` : undefined}>
                {title}
              </Typography>
            )}
            <Typography
              variant={isSecondary ? "paragraph-s" : "paragraph-m"}
              color={isSecondary ? "grey-600" : undefined}
              data-testid={dataTestId ? `${dataTestId}-description` : undefined}
            >
              {description}
            </Typography>
            {children}
          </Flex>
        </Flex>
        <Flex justify="center">
          <Button type={buttonType} size="small" onClick={onButtonClick} dataTestId={dataTestId ? `${dataTestId}-button` : undefined}>
            {buttonText}
          </Button>
        </Flex>
      </Flex>
    </Card>
  );
};

export default EmptyStateCard;
